import { Box, Heading } from 'grommet'
import styled, { css } from 'styled-components'

import { NormalizedWrapper } from '@theme'

export const Wrapper = styled(NormalizedWrapper)`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: ${theme.spaces[5] + theme.spaces[4]}px;
    position: relative;
    width: 100%;

    ${theme.below.laptopL`
      max-width: 998px;
    `}

    ${theme.below.laptopM`
      padding: 0 ${theme.spaces[3]}px;
    `}

    ${theme.below.laptop`
      justify-content: center;
      padding: 0 ${theme.newSpaces.sm}px;
      margin-top: ${theme.spaces[5]}px;

      & > div:not(:last-child) {
        margin-right: ${theme.spaces[4]}px;
      }
    `}

    ${theme.below.mobileXL`
      padding: 0 ${theme.newSpaces.lg}px;
      margin-top: ${theme.newSpaces.xl2}px;
    `}
  `}
`
export const Card = styled(Box)`
  ${({ theme }) => css`
    max-width: 320px;
    width: 100%;

    ${theme.below.laptopL`
      max-width: 290px;
    `}

    ${theme.below.tablet`
      max-width: 100%;
    `}
  `}
`

export const Title = styled(Heading)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title3')}

    color: ${theme.newColors.primary};
    margin-left: ${theme.spaces[3]}px;
    text-transform: uppercase;
  `}
`

export const TitleWrapper = styled(Box)`
  ${({ theme }) => css`
    align-items: center;
    flex-direction: row;
    margin: ${theme.spaces[3]}px 0;
  `}
`
